import { withRecommendSearchTermSection } from './withRecommendSearchTermSection'
import { ManageSearchTermTemplate } from '../ManageSearchTermTemplate'

const ConnectedSearchTermSection = withRecommendSearchTermSection(
  ManageSearchTermTemplate
)

export { ConnectedSearchTermSection as RecommendSearchTermSection }
